import { combineReducers } from '@reduxjs/toolkit'

import { REDUCER_INDEX } from '../../../constants'
import * as digestEmailTime from './digestEmailTime'

export * as digestEmailTime from './digestEmailTime'

export const actions = {
  ...digestEmailTime.actions,
}

export const epics = [...digestEmailTime.epics]

export const reducer = combineReducers({
  digestEmailTime: digestEmailTime.reducer,
})

interface State {
  digestEmailTime: ReturnType<typeof digestEmailTime.reducer>
}

export const selectors = {
  digestEmailTime: ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: { currentUser: { profile: State } } }) =>
    state.currentUser.profile.digestEmailTime,
}
